var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyDotdotdot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.71561 0.538452C2.28076 0.538452 2.73831 0.996527 2.73831 1.56115C2.73831 1.83224 2.63071 2.09235 2.4385 2.28457C2.24681 2.47626 1.98669 2.58438 1.71509 2.58438C1.14994 2.58438 0.692383 2.1263 0.692383 1.56168C0.692383 0.997049 1.15046 0.538974 1.71509 0.538974L1.71561 0.538452Z",
    fill: "#333D4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.28515 2.58386C9.84998 2.58386 10.3079 2.12598 10.3079 1.56115C10.3079 0.996332 9.84998 0.538452 9.28515 0.538452C8.72033 0.538452 8.26245 0.996332 8.26245 1.56115C8.26245 2.12598 8.72033 2.58386 9.28515 2.58386Z",
    fill: "#333D4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.50024 2.58386C6.06506 2.58386 6.52294 2.12598 6.52294 1.56115C6.52294 0.996332 6.06506 0.538452 5.50024 0.538452C4.93542 0.538452 4.47754 0.996332 4.47754 1.56115C4.47754 2.12598 4.93542 2.58386 5.50024 2.58386Z",
    fill: "#333D4B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyDotdotdot);
export default __webpack_public_path__ + "static/media/daily_dotdotdot.f845705470c9f4d748944ed94213942f.svg";
export { ForwardRef as ReactComponent };